/* esm.sh - applesauce-core@5.2.0/operations/profile */
export * from "/*applesauce-core@5.2.0/esnext/operations/profile.mjs";
